import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MerchantApi } from "../../../common/apis/merchant-api";
import { InputType } from "../../../common/components/input/enum/InputType";
import { ErrorHandling } from "../../../common/classes/ErrorHandling";
import { AppNavigator, NavigatorTarget } from "../../../services/app-navigator";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-merchant-email-confirmation-password',
  templateUrl: './merchant-email-confirmation-password.component.html',
  styleUrls: ['./merchant-email-confirmation-password.component.scss']
})
export class MerchantEmailConfirmationPasswordComponent {
  public showPasswordFieldText = false;
  public signInForm: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType;
  Validators = Validators

  token = ''

  emailLabel: string = $localize`:@@emailLabel:Email`;
  resetPassword: string = $localize`:@@resetPassword:Reset password`;
  backToLoginLabel: string = $localize`:@@backToLoginLabel:Back To Login`;

  constructor(private formBuilder: FormBuilder,
              private appNavigator: AppNavigator,
              private route: ActivatedRoute,
              private merchantApi: MerchantApi,
  ) {
  }

  ngOnInit() {
    this.token = this.route.snapshot.params['token'];

    if (this.token?.hasActualValue()) {
      this.merchantApi.merchantVerifyForgetPassword(this.token).subscribe({
        next: () => {
          this.navigateToChangePasswordWithToken();
        },
        error: (error) => {
          this.serverError = $localize`Something went wrong. Please try again later or contact support.`
        }
      });
    }
  }


  navigateToChangePasswordWithToken() {

    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantNewPassword, id: this.token })
  }

  onLoginClicked() {
    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
  }


}
